module.exports = __webpack_public_path__ + "img/ScanQRKH.5e31d7f9.png";